export default __webpack_public_path__ + "c-plus-plus.6fd0e352.png";